import * as React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

export default function Checkboxs({lists = [],filter="rate",onChange}) {
    const handleChange = (event) => {
        onChange(event.target,filter)
    }
  return (
    <FormGroup sx={{width : 260, display : 'flex', justifyContent: 'start'}}>
        {
            lists.map((l,index) => (
                <FormControlLabel key={index}  control={<Checkbox checked={l.checked} id={l.id} onChange={handleChange}/>} label={l.val} />
            ))
        }
    </FormGroup>
  );
}
